import { useEffect } from "react";
import { getConsent, CONSENT_EVENT } from "@/lib/consent";

// Mostra i popup alternati: promo (sconto) e catalogo, uno ogni 50 secondi.
const INTERVAL_MS = 50000;

export const PopupScheduler = () => {
  useEffect(() => {
    let firstT, interval, idx = 0, cleanupConsent;

    const start = () => {
      firstT = setTimeout(() => {
        window.dispatchEvent(new Event("sc-open-promo"));
        idx = 1;
      }, 1400);
      interval = setInterval(() => {
        window.dispatchEvent(new Event(idx % 2 === 0 ? "sc-open-promo" : "sc-open-catalog"));
        idx += 1;
      }, INTERVAL_MS);
    };

    if (getConsent()) {
      start();
    } else {
      const onConsent = () => start();
      window.addEventListener(CONSENT_EVENT, onConsent, { once: true });
      cleanupConsent = () => window.removeEventListener(CONSENT_EVENT, onConsent);
    }

    return () => { clearTimeout(firstT); clearInterval(interval); cleanupConsent && cleanupConsent(); };
  }, []);

  return null;
};
